import { useMutation, useQueryClient } from "react-query";

import { crearCentroCosto, updateCentroCosto, deleteCentroCosto} from '../../services/CentroCostos';

import { toast } from 'react-hot-toast';
const queryKey = "sucursal";

export const useCentroCostosMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addCentroCosto = useMutation((body) => crearCentroCosto(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
 
  const updateCentroC = useMutation(
    (body) => updateCentroCosto( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeCentroCosto = useMutation((id) => deleteCentroCosto( id), {
    onSuccess,
    onError,
  });

  return { addCentroCosto, updateCentroC, removeCentroCosto };
};
export default useCentroCostosMutations;